









































import { computed, defineComponent } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  setup() {
    const { store } = useVuex();
    const help = computed(() => store.state.Help);
    const showOverlay = computed(() => store.getters.Help.showHelpOverlay);
    const last = computed(() => store.getters.Help.lastHelpStep);

    const closeHelp = () => {
      store.commit.Help.setHelpOpen(false);
      setTimeout(() => {
        store.commit.Help.setActiveIndex(0);
      }, 300);
    };

    const openHelp = () => {
      store.commit.Help.setHelpOpen(true);
    };

    const next = () => {
      store.dispatch.Help.nextHelpStep();
    };

    return {
      help,
      showOverlay,
      last,
      closeHelp,
      openHelp,
      next
    };
  }
});
